import Dashboard from "@mui/icons-material/Dashboard";
import { Box } from "@mui/material";
import { PrimaryNavLink } from "@teamworksdev/nav";
import { trackEvent } from "../../reporting/reporting";

// full page path
export const NAV_ORG_AMS_DASHBOARD = "/org/ams-dashboard";

const DashboardIcon = () => {
  return (
    <Box sx={{ position: "relative" }}>
      <Dashboard />
    </Box>
  );
};
//IMPORTANT!:
// In order for the MFE to load properly, set VITE_WEB_DOMAIN="localhost:80"
export const amsDashboardLink: PrimaryNavLink = {
  to: NAV_ORG_AMS_DASHBOARD,
  name: (
    <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>Dashboard</Box>
  ) as unknown as string,
  icon: <DashboardIcon />,
  onClick: () => {
    trackEvent("Nutrition | Web | MFE | AMS Dashboard | Click", {});
  }
};
